<template>
  <a-drawer
    placement="right"
    :title="datas.noticetype"
    :width="870"
    :closable="true"
    :visible="visible"
    :mask-closable="false"
    :destroy-on-close="true"
    wrap-class-name="edit-notice-dia"
    @close="onClose"
  >
    <item-edit
      :item="cloneData"
      :hide="hide"
    />
  </a-drawer>
</template>
<script>
import ItemEdit from './ItemEdit'
import { cloneDeep } from 'lodash'
export default {
  components: {
    ItemEdit
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    datas: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      cloneData: {},
      itemData: {}
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.cloneData = cloneDeep(this.datas)
      }
    }
  },
  methods: {
    onClose () {
      this.hide()
    },
    hide () {
      // this.itemData = this.cloneData
      this.$emit('update:visible', false)
    }

  }
}
</script>
<style lang="scss">
.edit-notice-dia {
  .ant-drawer-header {
    border-bottom: none;
    padding-top: 32px;
    padding-left: 40px;
  }
  .ant-drawer-title {
    font-size: 32px;
    line-height: 56px;
  }
  .anticon-close {
    font-size: 32px;
    color: #d6d6d6;
  }
  .ant-drawer-close {
    right: 14px;
    top: 32px;
  }
}
</style>
